<script setup>
import { computed } from "vue";

import { first, get } from "lodash-es";

import VisitTinyurl from "@Components/sharing/VisitTinyurl.vue";
import QRDropdown from "@Components/sharing/QRDropdown.vue";
import ShareDropdown from "@Components/sharing/ShareDropdown.vue";
import CopyTinyurl from "@Components/sharing/CopyTinyurl.vue";

const emits = defineEmits(["on-shorten-another"]);

const props = defineProps({
  createdTinyurl: {
    type: Object,
    required: true,
  },
});

const mainAliases = computed(() => props.createdTinyurl.aliases[0].filter((alias) => alias.is_main));
const tinyurlActions = computed(() => {
  const prefix = "form";
  const url = decodeURI(mainAliases.value[0].tiny_url);

  return [
    { id: "visit-tinyurl", component: VisitTinyurl,  props: { prefix, url } },
    { id: "download-qr",   component: QRDropdown,    props: { prefix, url } },
    { id: "share-tinyurl", component: ShareDropdown, props: { prefix, url } },
    { id: "copy-tinyurl",  component: CopyTinyurl,   props: { prefix, url } },
  ];
});

function isAliasAffiliated(aliases) {
  return get(first(aliases), "affiliates");
}
</script>

<template>
  <div class="tinyurl-result">
    <div class="form-group mb-3">
      <label for="to-shorten-field">
        <img
          class="mr-2"
          src="@Images/home/url.svg"
          alt
        > Your Long URL
      </label>
      <input
        id="to-shorten-field"
        class="form-control form-control-lg text-break text-green"
        readonly
        :value="createdTinyurl.url"
      >
    </div>
    <div class="form-group mb-3">
      <label>
        <img
          class="mr-2"
          src="@Images/home/magic-wand.svg"
          alt
        > TinyURL
      </label>
      <div class="mt-n2">
        <input
          v-for="mainAlias in mainAliases"
          :key="mainAlias.id"
          data-test-id="dashboard_create_tinyurl_form_created_input"
          class="form-control form-control-lg mt-2 text-break text-green"
          readonly
          :value="decodeURI(mainAlias.tiny_url)"
        >
        <div
          v-if="isAliasAffiliated(mainAliases)"
          class="small"
        >
          {{ $t("tinyurl_affiliated_notice") }}
          <router-link :to="{ name: 'affiliateOptionPop' }">
            <u>{{ $t("learn_more") }}</u>
          </router-link>
        </div>
      </div>
    </div>
    <div class="d-flex flex-wrap mb-3">
      <component
        :is="action.component"
        v-for="action in tinyurlActions"
        :key="action.id"
        v-bind="action.props"
      />
    </div>
    <div class="d-flex flex-wrap-reverse m-n2">
      <div class="flex-grow-1 p-2">
        <button
          data-test-id="dashboard_create_tinyurl_form_shorten_another_btn"
          class="btn btn-xl btn-green btn-block text-nowrap"
          @click="emits('on-shorten-another')"
        >
          Shorten another
        </button>
      </div>
    </div>
  </div>
</template>
